var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThunderStorm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.69,
    height: 31.685,
    viewBox: "0 0 31.69 31.685",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Line",
    transform: "translate(-2 -2.003)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_475",
    "data-name": "Group 475",
    transform: "translate(3.443 21.447)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_451",
    "data-name": "Path 451",
    d: "M10.765,29.08A.72.72,0,0,0,9.8,29.4l-.72,1.44A.72.72,0,0,0,9.4,31.8a.67.67,0,0,0,.324.079.72.72,0,0,0,.641-.4l.72-1.44A.72.72,0,0,0,10.765,29.08Z",
    transform: "translate(-5.403 -29.003)",
    fill: "#83cfdf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_452",
    "data-name": "Path 452",
    d: "M37.765,29.08a.72.72,0,0,0-.965.317l-.72,1.44a.72.72,0,0,0,.317.965.67.67,0,0,0,.324.079.72.72,0,0,0,.641-.4l.72-1.44a.72.72,0,0,0-.317-.965Z",
    transform: "translate(-12.959 -29.003)",
    fill: "#83cfdf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_453",
    "data-name": "Path 453",
    d: "M9.362,41.5l.72-1.44A.72.72,0,0,0,8.8,39.414l-.72,1.44a.72.72,0,0,0,.317.965.67.67,0,0,0,.324.079A.72.72,0,0,0,9.362,41.5Z",
    transform: "translate(-5.123 -31.819)",
    fill: "#83cfdf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_454",
    "data-name": "Path 454",
    d: "M27.362,41.5l.72-1.44a.72.72,0,0,0-1.282-.648l-.72,1.44a.72.72,0,0,0,.317.965.67.67,0,0,0,.324.079A.72.72,0,0,0,27.362,41.5Z",
    transform: "translate(-10.16 -31.819)",
    fill: "#83cfdf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_455",
    "data-name": "Path 455",
    d: "M36.362,41.5l.72-1.44a.72.72,0,0,0-1.282-.648l-.72,1.44a.72.72,0,0,0,.317.965.67.67,0,0,0,.324.079A.72.72,0,0,0,36.362,41.5Z",
    transform: "translate(-12.679 -31.819)",
    fill: "#83cfdf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_456",
    "data-name": "Path 456",
    d: "M14.765,34.08a.72.72,0,0,0-.965.317l-.72,1.44a.72.72,0,0,0,.317.965.67.67,0,0,0,.324.079.72.72,0,0,0,.641-.4l.72-1.44A.72.72,0,0,0,14.765,34.08Z",
    transform: "translate(-6.522 -30.403)",
    fill: "#83cfdf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_457",
    "data-name": "Path 457",
    d: "M32.765,34.08a.72.72,0,0,0-.965.317l-.72,1.44a.72.72,0,0,0,.317.965.67.67,0,0,0,.324.079.72.72,0,0,0,.641-.4l.72-1.44A.72.72,0,0,0,32.765,34.08Z",
    transform: "translate(-11.56 -30.403)",
    fill: "#83cfdf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_458",
    "data-name": "Path 458",
    d: "M40.4,36.82a.67.67,0,0,0,.324.079.72.72,0,0,0,.641-.4l.72-1.44a.72.72,0,0,0-1.282-.648l-.72,1.44A.72.72,0,0,0,40.4,36.82Z",
    transform: "translate(-14.078 -30.42)",
    fill: "#83cfdf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_459",
    "data-name": "Path 459",
    d: "M5.765,34.08A.72.72,0,0,0,4.8,34.4l-.72,1.44A.72.72,0,0,0,4.4,36.8a.67.67,0,0,0,.324.079.72.72,0,0,0,.641-.4l.72-1.44A.72.72,0,0,0,5.765,34.08Z",
    transform: "translate(-4.003 -30.403)",
    fill: "#83cfdf"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_460",
    "data-name": "Path 460",
    d: "M27.016,30.018a.72.72,0,0,0-.655-.418H23.826l1.044-2.614A.72.72,0,0,0,24.2,26H19.88a.72.72,0,0,0-.677.468l-2.16,5.761a.72.72,0,0,0,.677.972h1.916l-1.916,6.272a.738.738,0,0,0,1.267.677l7.922-9.362a.72.72,0,0,0,.108-.771Z",
    transform: "translate(-4.197 -6.716)",
    fill: "#f8bc10"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_461",
    "data-name": "Path 461",
    d: "M8.669,20.725h20.7A4.321,4.321,0,0,0,33.686,16.4a5.25,5.25,0,0,0-5.135-5.459,5.762,5.762,0,0,0-9.8-5.034A6.481,6.481,0,0,0,6.321,8.482a2.024,2.024,0,0,0,0,.209A5.84,5.84,0,0,0,2,14.243v.072A6.6,6.6,0,0,0,8.669,20.725Z",
    transform: "translate(0 0)",
    fill: "#378ad3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThunderStorm);
export default __webpack_public_path__ + "static/media/thunderStorm.253e1f101c3e290ace7d0921834a51fe.svg";
export { ForwardRef as ReactComponent };